import HttpClient from "../client/httpclient";
import 'regenerator-runtime/runtime';

class BlogCard {
    constructor(DOMelement, openButtonsDOMlist) {
      try { 
        this.PageTitle = document.title;
        this.el = DOMelement;
        this.openButtons = openButtonsDOMlist;
        this.method = "GET";
        this.counter = 2;
        this.URL = '../src/components/room-card/blog-card.html?p=';
        this.loadMoreButton = document.getElementById("load__more__blogs");
        this.loadMoreButton.setAttribute("rel", "next");
        /*
        window.onpopstate = function(event) {
          console.log(event);          
          document.querySelector("link[rel='canonical']").href = event.state.path;
          var arrPageURL = event.state.path.split("=");          
          var arrDocumentTitle = document.title.split('|');
          if(arrDocumentTitle.length >1)
            this.PageTitle=arrDocumentTitle[1].trim();
          else
            this.PageTitle = arrDocumentTitle[0].trim();
          if(arrPageURL.length > 1){
            document.title = "Page " + arrPageURL[1] + " | " + this.PageTitle;
            this.counter = parseInt(arrPageURL[1]) + 1;
                HttpClient.AsyncGetRequest(this.URL, this.method)
            .then(card => {
              var blogCard = this.stringToHTML(card);
                for (var i = 0; i < blogCard.childNodes.length; i++) {
                  button.insertAdjacentElement("beforebegin", blogCard.childNodes[i]);
                  const observer = lozad();
                  observer.observe();
                }
                if(this.counter == this.totalpage - 1) {      
                  this.loadMoreButton.style.display = "none";
                }
            }).catch(error => {
              console.error(error)
            });
            this.counter = parseInt(arrPageURL[1]) + 1;
          }
          else{
            document.title = this.PageTitle;
            this.counter=2;
          }
        };*/
        

        this.loadMoreButton.href = window.location.href;
        
        function getParameterByName(name, url = window.location.href) {
          name = name.replace(/[\[\]]/g, '\\$&');
          var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
              results = regex.exec(url);
          if (!results) return null;
          if (!results[2]) return '';
          return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }

      var queryStringVal = getParameterByName('page');
      if(queryStringVal == null){
        var newurl = window.location.href;
        window.history.pushState({path:newurl},'',newurl);
        newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?page=2";
        this.loadMoreButton.href = newurl;
      }
      if(this.loadMoreButton) {
        this.URL = this.loadMoreButton.getAttribute("data-action");
        this.totalpage = this.loadMoreButton.getAttribute("data-totalpages");
        
      }


      if(queryStringVal && isNumeric(queryStringVal) && queryStringVal != '1'){
        document.querySelector("link[rel='canonical']").href = window.location.href;
        //document.title = "Page " + queryStringVal + " | " + this.PageTitle;
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?page=" + queryStringVal;
        window.history.pushState({path:newurl},'',newurl);
        newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?page=" + (parseInt(queryStringVal) + 1);
        this.loadMoreButton.href = newurl;
        
        var button = document.querySelector('.blog__cards-button');
        // HttpClient.AsyncGetRequest(this.URL, this.method)
        // .then(card => {
        //   var blogCard = this.stringToHTML(card);
        //     for (var i = 0; i < blogCard.childNodes.length; i++) {
        //       button.insertAdjacentElement("beforebegin", blogCard.childNodes[i]);
        //       const observer = lozad();
        //       observer.observe();
        //     }
            if(this.counter == this.totalpage ) {      
              this.loadMoreButton.style.display = "none";
              this.loadMoreButton.removeAttribute("href");
              this.loadMoreButton.removeAttribute("rel");
            }
            else
              this.loadMoreButton.setAttribute("rel", "next");
        // }).catch(error => {
        //   console.error(error)
        // });

        this.counter = parseInt(queryStringVal) + 1;
        if(parseInt(queryStringVal) >= (parseInt(this.totalpage)))
        {
          this.loadMoreButton.style.display = "none";
          this.loadMoreButton.removeAttribute("href");
          this.loadMoreButton.removeAttribute("rel");
        }
        else
          this.loadMoreButton.setAttribute("rel", "next");
      }

      if(this.totalpage == 1 )
        {
          this.loadMoreButton.style.display = "none";
          this.loadMoreButton.removeAttribute("href");
          this.loadMoreButton.removeAttribute("rel");
        }

      function isNumeric(str) {
        if (typeof str != "string") return false // we only process strings!  
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
               !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
      }
        
        
        
       /* 
       // 404 redirection
        if(parseInt(this.totalpage) < parseInt(this.counter))
        {
          let regex = /\/$/;
          var hostPath = window.location.host + window.location.pathname;
          let result = hostPath.replace(regex, "");
          window.location.href = window.location.protocol + "//" + result + "/404";
          return;
        }*/

        if (process.env.NODE_ENV === "development") {
          this.URL = '../src/components/blog-card/blog-card.html?p=';
        }

        [...openButtonsDOMlist].forEach((button) =>
        button.addEventListener("click", (event) => {
          event.preventDefault();
          this.loadMoreBlogs();
          this.updateString();
        })
      );        
      } catch (error) {
        console.log(error);
      }        
    }

    stringToHTML(str) {             
      const support = (function () {
        if (!window.DOMParser) return false;
        var parser = new DOMParser();
        try {
            parser.parseFromString('x', 'text/html');
        } catch(err) {
            return false;
        }
        return true;
      })();
      
      if (support) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(str, 'text/html');
          return doc.body;
      }
  
      var dom = document.createElement('div');
      dom.innerHTML = requestedCard.responseText;
      return dom;
             
    };
    updateString = function () {  
      if(this.counter < this.totalpage +1) {
        
        var url = `?page=${this.counter}`;
        var button = document.querySelector('.blog__cards-button');
        var hostPath = window.location.host + window.location.pathname;
        let regex = /\/$/;
        let result = hostPath.replace(regex, "");

        var newurl = window.location.protocol + "//" + result + url;
        
        document.querySelector("link[rel='canonical']").href = newurl;
        var arrPageTitle = this.PageTitle.split('|');
        if(arrPageTitle[0].indexOf('Page')>=0){arrPageTitle.shift()} 
        document.title = "Page " + this.counter + " | " + arrPageTitle.join("|");//
        //document.title = "Page " + this.counter + " | " + this.PageTitle;
        window.history.pushState({path:newurl},'',newurl);
        url = "?page=" + (parseInt(this.counter) + 1);
        newurl = window.location.protocol + "//" + result + url;
        this.loadMoreButton.href = newurl;
        if((parseInt(this.counter) + 1) > this.totalpage){
          this.loadMoreButton.removeAttribute("href"); 
          this.loadMoreButton.removeAttribute("rel");    
        }
        else
          this.loadMoreButton.setAttribute("rel", "next");
    }
  }

      loadMoreBlogs = async () => {    
        if(this.counter < this.totalpage +1) {
          const url = `${this.URL}&page=${this.counter}`;
          var button = document.querySelector('.blog__cards-button');
          await HttpClient.AsyncGetRequest(url, this.method)
          .then(card => {
            var blogCard = this.stringToHTML(card);
              for (var i = 0; i < blogCard.childNodes.length; i++) {
                var currentBlogcard = button.insertAdjacentElement("beforebegin", blogCard.childNodes[i]);
                //currentBlogcard.setAttribute("PageNumber", this.counter); 
                if(i==0){
                  currentBlogcard.setAttribute("tabindex", 0);
                  var x = window.scrollX, y = window.scrollY;
                  currentBlogcard.focus();
                  window.scrollTo(x, y + 450);
                   
                }
                const observer = lozad();
                observer.observe();
              }
              if(this.counter == this.totalpage) {      
                this.loadMoreButton.style.display = "none";
                this.loadMoreButton.removeAttribute("href");
                this.loadMoreButton.removeAttribute("rel");
              }
              else
                this.loadMoreButton.setAttribute("rel", "next");
                        
          }).catch(error => {
            console.error(error)
          });
          
        }
        this.counter = this.counter + 1; 
        
      };      
    }
export default BlogCard
